import { render } from "./EditUserAgenceModal.vue?vue&type=template&id=f0dc7142&ts=true"
import script from "./EditUserAgenceModal.vue?vue&type=script&lang=ts"
export * from "./EditUserAgenceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__